import { useCallback, useEffect, useRef, useState } from 'react';
import { fDate } from '../../../../utils/formatTime';

export const useCalendarHoverTooltip = ({ hoverDelayMs = 250, formatEventTime }) => {
  const hoverTooltipTimerRef = useRef(null);
  const [hoverTooltip, setHoverTooltip] = useState(null);

  const handleEventMouseEnter = useCallback(
    (mouseEnterInfo) => {
      if (hoverTooltipTimerRef.current) {
        clearTimeout(hoverTooltipTimerRef.current);
        hoverTooltipTimerRef.current = null;
      }

      const { event, jsEvent, el } = mouseEnterInfo;
      const extendedProps = event.extendedProps || {};

      const fallbackAnchor = {
        getBoundingClientRect: () => new DOMRect(jsEvent.clientX || 0, jsEvent.clientY || 0, 0, 0),
      };

      const tooltipData = {
        anchorEl: el || fallbackAnchor,
        placement: 'bottom',
        directionLabel: extendedProps.directionLabel,
        requestStatusName: extendedProps.requestStatusName,
        statusColor: extendedProps.statusColor,
        residentNames: extendedProps.residentNames,
        transportTypeName: extendedProps.transportTypeName,
        dateLabel: fDate(extendedProps.appointmentDateTime || event.start, 'EEEE, MMMM d'),
        timeLabel: extendedProps.appointmentDateTime
          ? formatEventTime(extendedProps.appointmentDateTime)
          : 'No time set',
      };

      hoverTooltipTimerRef.current = setTimeout(() => {
        setHoverTooltip(tooltipData);
        hoverTooltipTimerRef.current = null;
      }, hoverDelayMs);
    },
    [formatEventTime, hoverDelayMs]
  );

  const handleEventMouseLeave = useCallback(() => {
    if (hoverTooltipTimerRef.current) {
      clearTimeout(hoverTooltipTimerRef.current);
      hoverTooltipTimerRef.current = null;
    }
    setHoverTooltip(null);
  }, []);

  useEffect(() => () => clearTimeout(hoverTooltipTimerRef.current), []);

  return {
    hoverTooltip,
    handleEventMouseEnter,
    handleEventMouseLeave,
  };
};
